/* Cité Érotik — cart drawer Web Component */
(function () {
  'use strict';

  function money(cents) {
    return (window.theme && theme.formatMoney) ? theme.formatMoney(cents) : '$' + (cents / 100).toFixed(2);
  }

  class CartDrawer extends HTMLElement {
    connectedCallback() {
      this.panel = this.querySelector('[data-cart-panel]');
      this.scrim = this.querySelector('[data-cart-scrim]');
      this.itemsEl = this.querySelector('[data-cart-items]');
      this.footerEl = this.querySelector('[data-cart-footer]');
      this.subtotalEl = this.querySelector('[data-cart-subtotal]');

      document.addEventListener('click', (e) => {
        if (e.target.closest('[data-cart-toggle]')) { e.preventDefault(); this.open(); }
        else if (e.target.closest('[data-cart-close]') || e.target.closest('[data-cart-scrim]')) { this.close(); }
      });
      document.addEventListener('keydown', (e) => { if (e.key === 'Escape') this.close(); });

      // Quantity changes within the drawer
      this.itemsEl.addEventListener('click', (e) => {
        var btn = e.target.closest('[data-qty-change]');
        if (!btn) return;
        e.preventDefault();
        this.change(parseInt(btn.dataset.line, 10), parseInt(btn.dataset.qty, 10));
      });

      // Add-to-cart events from product forms
      document.addEventListener('cart:add', (e) => this.onAdded(e.detail));
    }

    open() { window.theme.openPanel(this.panel, this.scrim, 'translate-x-full'); }
    close() { window.theme.closePanel(this.panel, this.scrim, 'translate-x-full'); }

    async refresh() {
      try {
        var res = await fetch(window.theme.routes.cart + '.js');
        var cart = await res.json();
        this.render(cart);
      } catch (err) { /* noop */ }
    }

    onAdded() { this.refresh().then(() => this.open()); }

    async change(line, quantity) {
      try {
        var res = await fetch(window.theme.routes.cartChange, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ line: line, quantity: quantity })
        });
        var cart = await res.json();
        this.render(cart);
      } catch (err) { /* noop */ }
    }

    updateCounts(count) {
      document.querySelectorAll('[data-cart-count]').forEach((el) => {
        if (el.closest('cart-drawer')) {
          el.textContent = '(' + count + ')';
        } else {
          el.textContent = count;
          el.classList.toggle('hidden', count === 0);
        }
      });
    }

    render(cart) {
      this.updateCounts(cart.item_count);
      if (this.subtotalEl) this.subtotalEl.textContent = money(cart.total_price);
      if (this.footerEl) this.footerEl.classList.toggle('hidden', cart.item_count === 0);

      if (cart.item_count === 0) {
        this.itemsEl.innerHTML =
          '<div class="flex flex-col items-center justify-center text-center h-full p-8 gap-4">' +
          '<p class="text-on-surface-variant">Your cart is empty</p>' +
          '<a href="' + window.theme.routes.root + '" class="btn-tonal">Continue shopping</a></div>';
        return;
      }

      var html = '<ul class="divide-y divide-outline-variant">';
      cart.items.forEach((item, i) => {
        var line = i + 1;
        var img = item.image ? item.image.replace(/(\.[^.]*)$/, '_160x$1') : '';
        var variant = (item.variant_title && item.variant_title.indexOf('Default') === -1)
          ? '<p class="text-xs text-on-surface-variant mt-0.5">' + item.variant_title + '</p>' : '';
        html +=
          '<li class="flex gap-3 p-4">' +
            '<a href="' + item.url + '" class="shrink-0">' +
              (img ? '<img src="' + img + '" alt="" width="80" height="80" class="w-20 h-20 object-cover rounded-md bg-surface-container">' : '') +
            '</a>' +
            '<div class="flex-1 min-w-0">' +
              '<a href="' + item.url + '" class="block text-sm font-medium text-on-surface line-clamp-2">' + item.product_title + '</a>' +
              variant +
              '<p class="text-sm text-on-surface mt-1">' + money(item.final_price) + '</p>' +
              '<div class="flex items-center gap-3 mt-2">' +
                '<div class="inline-flex items-center border border-outline rounded-full">' +
                  '<button type="button" class="btn-icon h-9 w-9" data-qty-change data-line="' + line + '" data-qty="' + (item.quantity - 1) + '" aria-label="Decrease"><span class="material-symbols-outlined" style="font-size:18px">remove</span></button>' +
                  '<span class="w-8 text-center text-sm">' + item.quantity + '</span>' +
                  '<button type="button" class="btn-icon h-9 w-9" data-qty-change data-line="' + line + '" data-qty="' + (item.quantity + 1) + '" aria-label="Increase"><span class="material-symbols-outlined" style="font-size:18px">add</span></button>' +
                '</div>' +
                '<button type="button" class="text-xs text-on-surface-variant hover:text-error underline underline-offset-2" data-qty-change data-line="' + line + '" data-qty="0">Remove</button>' +
              '</div>' +
            '</div>' +
          '</li>';
      });
      html += '</ul>';
      this.itemsEl.innerHTML = html;
    }
  }
  if (!customElements.get('cart-drawer')) customElements.define('cart-drawer', CartDrawer);
})();
